import React, { Component, PropTypes } from 'react';
import ActionCreators from 'actions/ActionCreators';
import TelControl from 'components/TelControl';
import ButtonControl from 'components/ButtonControl';
import { translate as t } from 'lang';
import { sendRestorePassword, dumpState } from 'api';

import './RestorePasswordPhoneDialogContent.scss';

class RestorePasswordPhoneDialogContent extends Component {

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        method: PropTypes.string.isRequired,
        inputValue: PropTypes.string,
    }

    state = {
        phone: '',
        errors: {},
    }
    
    componentWillMount() {
        if (this.props.inputValue) {
            this.setState({
                phone: this.props.inputValue,
            });
        }
    }
    
    _onChangePhone = (event, value) => {
        this.setState({
            phone: value,
            errors: Object.assign(this.state.errors, {phone: ''})
        });
    }

    _onSubmit = () => {

        ActionCreators.showLoadingOverlay();

        return sendRestorePassword(this.props.method, this.state.phone)
            .then((errors) => {

                ActionCreators.hideLoadingOverlay();
    
                if (Object.keys(errors).length > 0) {
                    this.setState({
                        errors: errors
                    });
                } else {

                    this.setState({
                       errors: {},
                    });

                    if (this.props.onSubmit) {
                        this.props.onSubmit(this.state.phone);
                    }
                }
            })
            .catch(() => {
                ActionCreators.hideLoadingOverlay()
                dumpState()
                alert(t('SOMETHING_WENT_WRONG'))
            });
    }
    
    render() {
        return (
            <div className="RestorePasswordDialog RestorePasswordPhoneDialogContent">
                {this.state.errors.limit ?
                    <div className="RestorePasswordDialog-errorBox">{t(this.state.errors.limit)}</div>
                    : ''}
                <div className="RestorePasswordDialog-planBox">
                    {t('RESTORE_PASSWORD_PHONE_PLAN')}
                </div>
                <div className="RestorePasswordDialog-inputBox">
                    <TelControl className="RestorePasswordDialog-inputBoxInput"
                                onChange={this._onChangePhone}
                                error={this.state.errors.phone || ''}
                                value={this.state.phone} />
                    <ButtonControl className="RestorePasswordDialog-inputBoxButton RestorePasswordEmailDialogContent-inputBoxButton"
                                   view="sky"
                                   size="s"
                                   onClick={this._onSubmit}>
                        {t('CONTINUE')}
                    </ButtonControl>
                </div>
                <div className="RestorePasswordDialog-infoBox">
                    {t('RESTORE_PASSWORD_SMS_INFO')}
                </div>
            </div>
        );
    }
}

export default RestorePasswordPhoneDialogContent;



// WEBPACK FOOTER //
// ./client/components/RestorePasswordPhoneDialogContent/RestorePasswordPhoneDialogContent.js